import { z } from "zod";

export const loginInputSchema = z.object({ email: z.string().trim().toLowerCase().pipe(z.email().max(200)), password: z.string().min(1).max(200) });
export type LoginInput = z.infer<typeof loginInputSchema>;

export const userSchema = z.object({ id: z.string(), name: z.string(), email: z.string(), roleLabel: z.string() });
export type User = z.infer<typeof userSchema>;
